import {
  signIn as login,
  fetchAuthSession,
  signOut as logout,
} from "aws-amplify/auth";
import { get } from "lodash";

const sessionTokenName = "sessionData";

export const isAuthenticated = () => {
  const token = sessionStorage.getItem("isSignedIn");
  return !!token;
};

export const removeToken = () => {
  sessionStorage.setItem(sessionTokenName, "");
};

export const getToken = () => {
  return JSON.parse(sessionStorage.getItem(sessionTokenName))?.idToken || "";
};

export const getTokenFromCognito = async () => {
  var cognitoTokens = (await fetchAuthSession()).tokens;
  if (cognitoTokens) {
    sessionStorage.setItem(
      sessionTokenName,
      JSON.stringify(cognitoTokens?.idToken?.toString())
    );
    // let rawToken = cognitoTokens?.idToken?.toString();
    const userPayload = cognitoTokens?.idToken?.payload;
    sessionStorage.setItem("userPayload", JSON.stringify(userPayload));
    return userPayload;
  }
};

export const signIn = async (payload) => {
  try {
    const { username, password } = payload;
    const response = await login({ username, password });
    const token = get(
      response,
      ["signInUserSession", "idToken", "jwtToken"],
      ""
    );
    sessionStorage.setItem("isSignedIn", get(response, ["isSignedIn", ""]));
    getTokenFromCognito();
    return !!token;
  } catch (e) {
    throw e;
  }
};

export const signOut = async () => {
  await logout();
  sessionStorage.removeItem(sessionTokenName);
  sessionStorage.removeItem("userPayload");
};

export const getExpTime = async () => {
  const token = await getTokenFromCognito();
  return token?.exp;
};

export const getUserPrefferedName = () => {
  return JSON.parse(sessionStorage.getItem("sessionData"))?.userInfo
    ?.preferred_username;
};

export const checkIsAdmin = () => {
  return (
    JSON.parse(sessionStorage.getItem("sessionData"))?.userInfo
      ?.cognitoGroups === "admin"
  );
};

export const checkIsDoctor = () => {
  return (
    JSON.parse(sessionStorage.getItem("sessionData"))?.userInfo
      ?.cognitoGroups === "doctor"
  );
};

export const checkIsNurse = () => {
  return (
    JSON.parse(sessionStorage.getItem("sessionData"))?.userInfo
      ?.cognitoGroups === "nurse"
  );
};
